/* unplugin-vue-components disabled */import { render } from "./qrcodeAssembly.vue?vue&type=template&id=64f7b584&scoped=true"
import script from "./qrcodeAssembly.vue?vue&type=script&lang=js"
export * from "./qrcodeAssembly.vue?vue&type=script&lang=js"

import "./qrcodeAssembly.vue?vue&type=style&index=0&id=64f7b584&scoped=true&lang=css"

import exportComponent from "E:\\work\\wwwroot\\new-landing-page-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f7b584"]])

export default __exports__